import React from 'react';
import * as styles from './style.module.css';
import { Link } from 'gatsby';

const QuickLinks = ({ block }) => {
  const { links } = block;

  // console.log(links);

  return (
    <div className="container">
      <div className={styles.cardContainer}>
        {links.map((link) => {
          const slug = link.slug.startsWith('/') ? link.slug : `/${link.slug}`;
          const slugWithoutDomain = slug.replace('https://www.mymathscloud.com/', '');
          return (
            <div className={styles.card} key={slugWithoutDomain}>
              <Link to={slugWithoutDomain}>{link.title}</Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuickLinks;
